// extracted by css-extract-rspack-plugin
export default {"icon":"dJYLzKbelLMDnWYz","tag":"qdLN4Uru6RAyzPNh","active":"wj9GDRocoxEFwHVL","tags":"tmI3TDWJuW4VWZWI"};